/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useHasEditorToRendererCommunicator } from '../../editor-page/render-context/editor-to-renderer-communicator-context-provider'
import { cypressId } from '../../../utils/cypress-attribute'
import { useNoteSettingsContext } from '../note-settings/note-settings-context'
import { NoteInfoLineContributors } from './note-info-line-contributors'
import { NoteInfoLineCreatedAt } from './note-info-line-created-at'
import { NoteInfoLineUpdatedAt } from './note-info-line-updated-at'
import { NoteInfoLineUpdatedBy } from './note-info-line-updated-by'
import { NoteInfoLineWordCount } from './note-info-line-word-count'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

/**
 * Renders information about the creation and the changes of the note given by the surrounding
 * {@link NoteSettingsProvider}. The word count is calculated by the renderer, so it is only shown
 * for the opened note on pages that have a renderer.
 */
export const NoteInfoSection: React.FC = () => {
  const { isOpenNote } = useNoteSettingsContext()
  const hasRenderer = useHasEditorToRendererCommunicator()

  return (
    <Row xs={1} sm={2} className={'g-0'} {...cypressId('note-info-section')}>
      <Col>
        <NoteInfoLineCreatedAt />
      </Col>
      <Col>
        <NoteInfoLineUpdatedAt />
      </Col>
      <Col>
        <NoteInfoLineUpdatedBy />
      </Col>
      <Col>
        <NoteInfoLineContributors />
      </Col>
      {isOpenNote && hasRenderer && (
        <Col>
          <NoteInfoLineWordCount visible={true} />
        </Col>
      )}
    </Row>
  )
}
